import { createStyles, makeStyles } from '@material-ui/core/styles';
import { YELLOW } from 'constants/colors';
export default makeStyles(() => createStyles({
  unpaidInvoicesStyling: {
    backgroundColor: YELLOW,
    minHeight: '22px',
    height: '22px',
    minWidth: '22px',
    width: '22px',
    fontSize: '18px'
  },
  infoText: {
    display: 'flex',
    flexDirection: 'column'
  }
}));